import { Price } from '@wix/package-picker-components';
import { observer } from 'mobx-react';
import { AdvancedPlansProductModel } from 'models/AdvancedPlansProductModel';
import { RootStore, withInjectedRootStore } from 'providers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { taxIncludedTranslationKey } from '../../../../../../constants';

interface ProductCardProps {
  product: AdvancedPlansProductModel;
  size: 'small' | 'tiny';
  rootStore: RootStore;
}

const ProductPriceComp: React.FC<ProductCardProps> = ({
  product,
  size,
  rootStore,
}) => {
  const { t } = useTranslation();
  const {
    appContext: { country, currentPlanDetails },
    pricesIncludeTax,
    currentCycle,
    isChangePlan,
  } = rootStore.appStore;
  const cycle = currentPlanDetails?.paymentCycle || currentCycle;
  const fullPrice = isChangePlan
    ? product.getFullPriceByCycle(cycle)
    : product.getYearlyFullPrice();
  const actualPrice = isChangePlan
    ? product.getActualPriceByCycle(cycle)
    : product.getFirstCycleYearlyMonthly() || product.getYearlyActualPrice();

  return (
    <Price
      size={size}
      price={actualPrice}
      fullPrice={fullPrice}
      cycleLabel={`/${t('product_price.month')}`}
      taxIncludedLabel={t(taxIncludedTranslationKey[country])}
      shouldShowTaxIncludedLabel={pricesIncludeTax}
      shouldShowProductFullPrice={false}
    />
  );
};

export const ProductPrice = observer(withInjectedRootStore(ProductPriceComp));
